import * as React from "react";
import { styled } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import styles from "./style";


const BpIcon = styled("span")(() => ({
  borderRadius: "50%",
  width: 16,
  height: 16,
  backgroundColor: "#D9D9D9",
  "input:hover ~ &": {
    backgroundColor: "#D9D9D9",
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#28AA4A",
  backgroundImage: "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&::before": {
    display: "block",
    width: 16,
    height: 16,
    backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
    content: "''",
  },

  "input:hover ~ &": {
    backgroundColor: "#28AA4A",
  },
});

// Inspired by blueprintjs
function BpRadio(props) {
  return (
    <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

export function CustomizedRadios({ handleChange, value, vatNumber, gstNumber }) {
  return (
    <FormControl>
      <RadioGroup
        value={value}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"
        onChange={e => handleChange(e.target.value)}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
          <Box sx={styles.radioContainer}>
            <FormControlLabel name="vatNumber" defaultChecked={vatNumber} checked={value === "vatNumber"} sx={styles.radioBtn} value="vatNumber" control={<BpRadio />} />
            <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>VAT Number</Typography>

            <Box sx={styles.radioContainers}>
              <FormControlLabel name="gstNumber" defaultChecked={gstNumber} checked={value === "gstNumber"} sx={styles.radioBtn} value="gstNumber" control={<BpRadio />} />
              <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>GST Number</Typography></Box>

          </Box>
        </Box>
      </RadioGroup>
    </FormControl>
  );
}

export function CustomizedRadio({ handleChange, value, radioLabel, defaultChecked, disablePercentage }) {
  return (
    <FormControl>
      <RadioGroup
        value={value}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"
        onChange={e => handleChange(e.target.value)}
      >
        <Box sx={{ display: { xs: "block", md: "flex" }, justifyContent: "space-between", }}>
          {radioLabel?.map((item, index) => {
            const isDisabled = disablePercentage && item.value === "percentage";
            return (
              <Box sx={styles.radioContainer} key={index}>
                <FormControlLabel name={item?.value} defaultChecked={defaultChecked} checked={(value === item?.value)} value={item?.value} control={<BpRadio disabled={isDisabled} />}
                  sx={{
                    ...styles.radioBtn,
                    ...(isDisabled && {
                      opacity: 0.5,
                      cursor: 'not-allowed !important'
                    }),
                  }}
                  disabled={isDisabled}
                />
                <Typography sx={{
                  fontSize: "12px", fontWeight: "500", ml: 1, mr: 2, ...(isDisabled && {
                    opacity: 0.5,
                    color: 'text.disabled'
                  })
                }}>{item?.label}</Typography>
              </Box>
            )
          })}

        </Box>
      </RadioGroup>
    </FormControl>
  );
}
export function CustomizedRadiosAddPension({ handleChange, value, typeC, typeE }) {
  return (
    <FormControl>
      <RadioGroup
        value={value}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"
        onChange={e => handleChange(e.target.value)}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={styles.radioContainer}>
            <FormControlLabel name="vatNumber" defaultChecked={typeC} checked={value === "Pension - paid by company to fund"} sx={styles.radioBtn} value="Pension - paid by company to fund" control={<BpRadio />} />
            <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>Pension - paid by company to fund</Typography>

            <Box sx={styles.radioContainers}>
              <FormControlLabel name="gstNumber" defaultChecked={typeE} checked={value === "Pension - paid directly by employee"} sx={styles.radioBtn} value="Pension - paid directly by employee" control={<BpRadio />} />
              <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>Pension - paid directly by employee</Typography></Box>

          </Box>
        </Box>
      </RadioGroup>
    </FormControl>
  );
}
export function CustomizedRadiosAddAmount({ handleChange, value, Amount, Percentage }) {
  return (
    <FormControl>
      <RadioGroup
        value={value}
        aria-labelledby="demo-customized-radios"
        name="customized-radios"
        onChange={e => handleChange(e.target.value)}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box sx={styles.radioContainer}>
            <FormControlLabel name="amount" defaultChecked={Amount} checked={value === "Amount"} sx={styles.radioBtn} value="Amount" control={<BpRadio />} />
            <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>Amount</Typography>

            <Box sx={styles.radioContainers}>
              <FormControlLabel name="gstNumber" defaultChecked={Percentage} checked={value === "Percentage"} sx={styles.radioBtn} value="Percentage" control={<BpRadio />} />
              <Typography sx={{ fontSize: "12px", fontWeight: "500", ml: 1 }}>Percentage of: Salary</Typography></Box>

          </Box>
        </Box>
      </RadioGroup>
    </FormControl>
  );
}
